export default __webpack_public_path__ + "static/media/app-bill.c54ad4e7.svg";